/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import * as d3 from 'd3';
import React from 'react';
import {
  Bar, BarChart as ReBarChart,
  CartesianGrid, Tooltip, XAxis, YAxis
} from 'recharts';
import CustomTooltip from './CustomTooltip';
import ResponsiveContainer from './ResponsiveContainer';

function HorizontalBarChart({
  width = 450, height = 300, keys, groupKey, data, ready, title, colors, valueFormatter = null,
  showYTick = true, tooltipFormatter,
}) {
  const color = d3.scaleOrdinal().range(colors);
  // const labelColor = d3.hsl(color).l > 0.5 ? '#000' : '#fff';

  function renderBars() {
    return keys.map((k) => (
      <Bar
        key={k}
        dataKey={k}
        fill={color(k)}
        label={{
          position: 'right',
          formatter: valueFormatter,
          fill: '#000',
        }}
      />
    ));
  }

  return (
    <>
      <Typography variant="body2" align="center"><strong>{title}</strong></Typography>
      <ResponsiveContainer width="100%" height={height}>
        <ReBarChart
          data={data}
          layout="vertical"
          margin={{
            top: 20, right: 60, left: 40, bottom: 0,
          }}
        >
          <XAxis type="number" tickFormatter={valueFormatter} />
          <YAxis dataKey={groupKey} type="category" tick={showYTick} />

          <Tooltip
            cursor={false}
            content={(
              <CustomTooltip
                formatterFunction={tooltipFormatter}
                valueFormatter={valueFormatter}
              />
            )}
          />
          <CartesianGrid horizontal={false} />
          {renderBars()}
        </ReBarChart>
      </ResponsiveContainer>
    </>
  );
}

export default HorizontalBarChart;
